import { useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0)

  const testimonials = [
    {
      id: 1,
      title: "Cindy's Emergency Move",
      image: "https://static2.givesendgo.com/images/campaign_image/97921193f7b4616186ce4eb892a01c50.png",
      excerpt: "Thank you to everyone who has donated. I appreciate it. God bless you all"
    },
    {
      id: 2,
      title: "Wimberley Service Industry Relief Fund",
      image: "https://static2.givesendgo.com/images/campaign_image/33dfd0addea77264db08a39359ebc219.png",
      excerpt: "Hi everyone I'm Dwight the one that was involved in the accident on April 11th I'm ok just healing up..."
    },
    {
      id: 3,
      title: "Still Standing Support Our Legal Defense",
      image: "https://static2.givesendgo.com/images/logo_og.jpg",
      excerpt: "We did it. In just 9 hours, 176 donors helped us raise $20,000. We're overwhelmed and humbled..."
    }
  ]

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length)
  }

  return (
    <div className="relative z-10 flex flex-col items-center justify-center px-4 mt-0 space-y-4 overflow-hidden xl:space-y-16 xl:mt-16 py-16">
      <section className="p-0 absolute inset-0">
        <canvas id="c" className="canvas"></canvas>
      </section>
      
      <div className="relative z-20 flex flex-col justify-center pt-10 pb-8 space-y-4 xl:space-y-10 testimonial-wrapper md:pb-10">
        <div className="heading-wrapper">
          <h2 className="text-center text-3xl md:text-4xl font-bold text-gsg-gray-dark mb-4">
            Testimonials
          </h2>
        </div>
        
        <div className="flex items-center w-full mx-auto slider-wrapper max-w-6xl">
          <button 
            onClick={prevSlide}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors mr-4"
          >
            <ChevronLeftIcon className="w-8 h-8 text-gsg-teal" />
          </button>
          
          <div className="flex-1 overflow-hidden">
            <div 
              className="flex transition-transform duration-300"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial) => (
                <div 
                  key={testimonial.id} 
                  className="w-full flex-shrink-0 p-4"
                >
                  <div className="flex flex-col items-center justify-center w-full p-0 md:p-6 lg:flex-row xl:p-0">
                    <div className="flex flex-col w-full rounded-lg shadow bg-gradient-to-tr lg:shadow-xl xl:flex-row from-neutral-50 to-neutral-100 min-h-80">
                      <div className="flex w-full xl:w-1/2">
                        <img 
                          className="object-cover object-center w-full max-w-full rounded-t-lg xl:rounded-tr-none xl:rounded-s-lg testimonial-image h-64 xl:h-auto"
                          src={testimonial.image}
                          alt={testimonial.title}
                        />
                      </div>
                      <div className="flex flex-col items-start justify-center w-full max-w-xl p-6 align-middle xl:px-10 xl:w-1/2">
                        <h4 className="text-2xl font-semibold text-left campaign-name text-gsg-gray-dark mb-4">
                          {testimonial.title}
                        </h4>
                        <p className="text-left text-gray-600 line-clamp-3">
                          {testimonial.excerpt}
                        </p>
                        <div className="mt-5">
                          <a href="/testimonials" className="text-gsg-teal hover:text-gsg-teal-dark font-semibold">
                            Read more →
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <button 
            onClick={nextSlide}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors ml-4"
          >
            <ChevronRightIcon className="w-8 h-8 text-gsg-teal" />
          </button>
        </div>
        
        {/* Dots Indicator */}
        <div className="flex justify-center space-x-2 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                currentSlide === index ? 'bg-gsg-teal' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Testimonials